module.exports = __webpack_public_path__ + "img/link-05.e05ecb5d.svg";